import { FeiertagskontoContent } from '@/domain/mitarbeiter/features/feiertagskonto/features/feiertagskonto/FeiertagskontoContent';
import { KontoausgleichMobile } from '@/domain/mitarbeiter/features/feiertagskonto/features/kontoausgleich/KontoausgleichMobile';

export function FeiertagskontoContentMobile() {
  return (
    <div className="flex flex-col gap-8">
      <FeiertagskontoContent className="flex-col" />
      <KontoausgleichMobile />
    </div>
  );
}
